module.exports = __webpack_public_path__ + "c86fc34015d5c161f8f7ea945527bd57.svg";